
import { defineComponent, PropType } from 'vue'
import { IssueFilterChoice } from '~/types/issues'
import { shortenLargeNumber } from '~/utils/string'

export default defineComponent({
  name: 'CategorySelectorMobile',

  props: {
    activeSidebarItem: {
      type: String,
      default: 'recommended'
    },
    issueCategories: {
      type: Array as PropType<IssueFilterChoice[]>,
      default: () => []
    },
    occurrenceCounts: {
      type: Object as PropType<Record<string, number>>,
      default: () => ({})
    }
  },

  emits: ['updateCategory'],

  data() {
    return {
      isModalOpen: false
    }
  },

  computed: {
    activeIssueCategory(): IssueFilterChoice {
      return (
        this.issueCategories.find(
          (issueCategory) => issueCategory.shortcode === this.activeSidebarItem
        ) || ({} as IssueFilterChoice)
      )
    }
  },

  mounted() {
    const vh = window.innerHeight
    document.documentElement.style.setProperty('--window-inner-height', `${vh}px`)
  },

  methods: {
    shortenLargeNumber,

    closeModal() {
      this.isModalOpen = false
    },

    updateCategory(shortcode: string) {
      this.$emit('updateCategory', shortcode)
      this.closeModal()
    }
  }
})
